<script>
  export let text;
  export let img;
</script>

<div class="subscriptions-section-heading">
  <img
    class="subscriptions-section-heading-image"
    src={img}
    alt=""
    style="max-width: 200px;" />
  <h2>{text}</h2>
</div>
